import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "mr-2"
};
const _hoisted_2 = {
  class: "pr-2"
};
const _hoisted_3 = {
  class: "text-white font-bold white-space-nowrap"
};
const _hoisted_4 = {
  class: "text-white text-xs white-space-nowrap"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Avatar = _resolveComponent("Avatar");
  const _component_SelectBrandDialog = _resolveComponent("SelectBrandDialog");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", {
    class: "flex align-items-center mr-5 cursor-pointer",
    onClick: _cache[0] || (_cache[0] = $event => $options.open())
  }, [_createElementVNode("div", _hoisted_1, [_createVNode(_component_Avatar, {
    size: "large",
    shape: "circle",
    image: $data.store.currentBrand?.logo ? $data.store.currentBrand.logo : null
  }, null, 8, ["image"])]), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, _toDisplayString($data.store.currentBrand?.brand_name ? $data.store.currentBrand?.brand_name : "Select Brand"), 1), _createElementVNode("div", _hoisted_4, _toDisplayString($data.store.currentBrand?.company?.company_name ? $data.store.currentBrand?.company?.company_name : "Click here to select"), 1)]), _cache[1] || (_cache[1] = _createElementVNode("i", {
    class: "pi pi-angle-down ml-auto text-white"
  }, null, -1))]), _createVNode(_component_SelectBrandDialog)], 64);
}